import { reducer } from 'redux-form';

export default reducer;
